export const myInfoFunctionURL = "https://func-smartbar-server.azurewebsites.net/api/MyInformation";
export const confirmEmailFunctionURL = "https://func-smartbar-server.azurewebsites.net/api/ConfirmEmail"
export const sendConfirmationEmailFunctionURL = "https://func-smartbar-server.azurewebsites.net/api/SendConfirmationEmail"
export const validateTokenFunctionURL = "https://func-smartbar-server.azurewebsites.net/api/ValidateToken";
export const createTaskFunctionURL = "https://func-smartbar-server.azurewebsites.net/api/CreateTask";
export const deleteTokenFunctionURL = "https://func-smartbar-server.azurewebsites.net/api/DeleteToken";

// export const myInfoFunctionURL = "http://localhost:7186/api/MyInformation"
// export const confirmEmailFunctionURL = "http://localhost:7186/api/ConfirmEmail"
// export const sendConfirmationEmailFunctionURL = "http://localhost:7186/api/SendConfirmationEmail"
// export const validateTokenFunctionURL = "http://localhost:7186/api/ValidateToken"
// export const createTaskFunctionURL = "http://localhost:7186/api/CreateTask"
// export const deleteTokenFunctionURL = "http://localhost:7186/api/DeleteToken"

export const appURL = "https://smartbarservice.mediamarktsaturn.com"

export const encryptKey = "dJ5OoLP2cWNFh0MiqGUzb7RHXw93FsQ9X4F4oPsUloGuAzFuDi6T4A==";

export const datenSchutzBlobURL = "https://staccsmartbar.blob.core.windows.net/containersmartbar/Datenschutzinformation Smartbar.docx"

// categories.ts
export const categories: Record<number, string> = {
  1: 'Datenübertragung Android zu Apple IOS mit Picea Switch',
  2: 'Datenübertragung Apple IOS zu Android mit Picea Switch',
  3: 'Datenübertragung Apple IOS zu Apple IOS mit Picea Switch',
  4: 'Datenübertragung Android zu Android mit Picea Switch',
  5: 'Einrichtung Notebook mit MS Konto',
  6: 'Einrichtung Notebook ohne MS Konto',
  7: 'Einrichtung Smartwatch',
  8: 'Einrichtung Startklar Komfort und Premium Android',
  9: 'Einrichtung Startklar Premium und Komfort für Iphone',
  10: 'Software Installation McAffee',
};

//date helpers
const today = new Date();
export const minDate = "1925-01-01";
export const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())
  .toISOString()
  .split("T")[0];

// Usage: categories[processIdInt] or categories[Number(processId)]

export const fieldMapping: Record<string, string> = {
  email: "Email",
  vorname: "Vorname",
  nachname: "Nachname",
  koerpergewicht: "WeightKg",
  koerpergroesse: "HeightCm",
  zugangsdaten: "ZugangsDaten",
  sonstiges: "Sonstige",
  password: "Passwort",
  pin: "PIN",
  sperrcode: "Sperrcode",
  geburtsdatum: "Geburtsdatum",
  benutzername: "Benutzername",
  sicherheitsfrage: "Sicherheitsfrage",
  verifizierungscode: "Verifizierungscode"
};

export const transformPayload = (
  data: Record<string, any>,
  tokenID: string,
  confirmedEmail: string,
  processID: number
): Record<string, any> => {
  const transformedData: Record<string, any> = {};

  Object.keys(data).forEach((key) => {
    if (data[key].trim() === "") return; // Skip empty keys

    const mappedKey = fieldMapping[key] || key;
    transformedData[mappedKey] = data[key];
  });

  transformedData["TokenID"] = tokenID;
  transformedData["ConfirmedEmail"] = confirmedEmail;
  transformedData["ProcessID"] = processID;

  return transformedData;
};